"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
/* eslint:disable */
var BiLoggerFactory = require("@wix/wix-bi-logger-client/dist/bi-logger-factory");
/**
* @typedef {string} Url
*/
/**
* @typedef {string} GUID
*/
/**
* @typedef {number} DateTime
*/
var dummy;
var defaultConfig = { endpoint: 'podcast' };
var init = function (webOrMobileLogger) { return function (userConfig) {
    if (userConfig === void 0) { userConfig = {}; }
    var defaults = userConfig.defaults, restOfConfig = __rest(userConfig, ["defaults"]);
    var config = __assign({}, defaultConfig, restOfConfig);
    var factoryInstance = (webOrMobileLogger instanceof BiLoggerFactory) ? webOrMobileLogger : webOrMobileLogger.factory(config);
    var logger = getLogger(factoryInstance);
    return defaults ? logger.util.updateDefaults(defaults) : logger;
}; };
exports.initCustomLogger = function (factoryInstance) { return getLogger(factoryInstance); };
var getLogger = function (biLoggerClientFactoryInstance) {
    return new Logger(biLoggerClientFactoryInstance);
};
var Logger = /** @class */ (function () {
    function Logger(biLoggerClientFactoryInstance) {
        var _this = this;
        this.biLoggerClientFactoryInstance = biLoggerClientFactoryInstance;
        this.util = {
            updateDefaults: function (defaults) {
                _this.biLoggerClientFactoryInstance.updateDefaults(defaults);
                return _this;
            },
            log: function (logParams) {
                return _this.bi.log(logParams);
            }
        };
        biLoggerClientFactoryInstance
            .updateDefaults({ src: 9 });
        this.bi = biLoggerClientFactoryInstance.logger({ endpoint: 'podcast' });
    }
    ;
    /**
    * @typedef {Object} episodeNavigationClickParams
    * @property {string} artifactVersion - app version for debug, not mandatory
    * @property {string} button - next / previous
    * @property {string} episodeId - episode id current
    * @property {string} feedId - feed id
    * @property {GUID} playerInstanceID - mandatory
    * @property {GUID} sid - mandatory
    * @property {string} compId - player_id
    * @property {string} requestedEpisodeId - requested episode id
    * @property {string} sessionId - session id
    * @property {GUID} visitorId - visitor_id, mandatory
    **/
    /**
     * Name: widget.episode.navigation.click. Evid: 910.
     * Event description: User clicks on Previous Episode / Next episode / all episodes navigation.
    
     * artifactVersion - Type: string. Desc: app version for debug, not mandatory
     *
     * button - Type: string. Desc: next / previous
     *
     * episodeId - Type: string. Desc: episode id current
     *
     * feedId - Type: string. Desc: feed id
     *
     * playerInstanceID - Type: guid. Desc: mandatory
     *
     * sid - Type: guid. Desc: mandatory
     *
     * compId - Type: string. Desc: player_id
     *
     * requestedEpisodeId - Type: string. Desc: requested episode id
     *
     * sessionId - Type: string. Desc: session id
     *
     * visitorId - Type: guid. Desc: visitor_id, mandatory
     * @param {episodeNavigationClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.episodeNavigationClick = function (params) {
        return this.bi.log(__assign({ evid: 910 }, params));
    };
    /**
    * @typedef {Object} episodeEnclosureErrorParams
    * @property {string} artifactVersion - app version for debug, not mandatory
    * @property {string} correlationId - correlation with play start
    * @property {string} enclosureUrl - enclosure url
    * @property {string} errorType - error
    * @property {string} feedId - feed id
    * @property {GUID} playerInstanceID - mandatory
    * @property {GUID} sid - mandatory
    * @property {string} compId - player_id
    * @property {string} sessionId - session id
    * @property {GUID} visitorId - visitor_id, mandatory
    **/
    /**
     * Name: widget.episode.enclosure.error. Evid: 904.
     * Event description: Widget play error.
    
     * artifactVersion - Type: string. Desc: app version for debug, not mandatory
     *
     * correlationId - Type: string. Desc: correlation with play start
     *
     * enclosureUrl - Type: string. Desc: enclosure url
     *
     * errorType - Type: string. Desc: error
     *
     * feedId - Type: string. Desc: feed id
     *
     * playerInstanceID - Type: guid. Desc: mandatory
     *
     * sid - Type: guid. Desc: mandatory
     *
     * compId - Type: string. Desc: player_id
     *
     * sessionId - Type: string. Desc: session id
     *
     * visitorId - Type: guid. Desc: visitor_id, mandatory
     * @param {episodeEnclosureErrorParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.episodeEnclosureError = function (params) {
        return this.bi.log(__assign({ evid: 904 }, params));
    };
    /**
    * @typedef {Object} loadMoreCompletedParams
    * @property {string} artifactVersion - null
    * @property {number} episodesCount - new loaded episodes shown
    * @property {string} feedId - feed id
    * @property {GUID} playerInstanceID - null
    * @property {number} loadTime - ms
    * @property {GUID} sid - null
    * @property {string} compId - player_id
    * @property {string} sessionId - null
    **/
    /**
     * Name: widget.loadMore.completed. Evid: 913.
     * Event description: UoU clicks on Load More on main podcast page and episodes loaded.
    
     * artifactVersion - Type: string.
     *
     * episodesCount - Type: numeric. Desc: new loaded episodes shown
     *
     * feedId - Type: string. Desc: feed id
     *
     * playerInstanceID - Type: guid.
     *
     * loadTime - Type: numeric. Desc: ms
     *
     * sid - Type: guid.
     *
     * compId - Type: string. Desc: player_id
     *
     * sessionId - Type: string.
     * @param {loadMoreCompletedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.loadMoreCompleted = function (params) {
        return this.bi.log(__assign({ evid: 913 }, params));
    };
    /**
    * @typedef {Object} navigationRequestedParams
    * @property {string} artifactVersion - app version for debug, not mandatory
    * @property {string} correlationId - one uniq guid per one load process
    * @property {string} episodeId - episode id
    * @property {string} feedId - feed id
    * @property {GUID} playerInstanceID - mandatory
    * @property {GUID} sid - mandatory
    * @property {string} pageType - (where users tries to go (episode / main)
    * @property {string} compId - player_id
    * @property {string} sessionId - session id
    * @property {GUID} visitorId - visitor_id, mandatory
    **/
    /**
     * Name: widget.navigation.requested. Evid: 905.
     * Event description: User of user tries to go to another page in a app.
    
     * artifactVersion - Type: string. Desc: app version for debug, not mandatory
     *
     * correlationId - Type: string. Desc: one uniq guid per one load process
     *
     * episodeId - Type: string. Desc: episode id
     *
     * feedId - Type: string. Desc: feed id
     *
     * playerInstanceID - Type: guid. Desc: mandatory
     *
     * sid - Type: guid. Desc: mandatory
     *
     * pageType - Type: string. Desc: (where users tries to go (episode / main)
     *
     * compId - Type: string. Desc: player_id
     *
     * sessionId - Type: string. Desc: session id
     *
     * visitorId - Type: guid. Desc: visitor_id, mandatory
     * @param {navigationRequestedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.navigationRequested = function (params) {
        return this.bi.log(__assign({ evid: 905 }, params));
    };
    /**
    * @typedef {Object} widgetEpisodeStatsParams
    * @property {string} artifactVersion - app version for debug, not mandatory
    * @property {DateTime} dateUpdated - created / updated date
    * @property {string} episodeId - episode id
    * @property {string} feedId - feed id
    * @property {boolean} hasDescription - is plain text description existing
    * @property {boolean} hasImage - is image existing
    * @property {GUID} playerInstanceID - mandatory
    * @property {GUID} sid - mandatory
    * @property {string} compId - player_id
    * @property {string} sessionId - session id
    * @property {string} type - video / track / download_only
    * @property {GUID} visitorId - visitor_id, mandatory
    **/
    /**
     * Name: widget.episode.stats. Evid: 911.
     * Event description: Episode current state, send after episode page open.
    
     * artifactVersion - Type: string. Desc: app version for debug, not mandatory
     *
     * dateUpdated - Type: datetime. Desc: created / updated date
     *
     * episodeId - Type: string. Desc: episode id
     *
     * feedId - Type: string. Desc: feed id
     *
     * hasDescription - Type: bool. Desc: is plain text description existing
     *
     * hasImage - Type: bool. Desc: is image existing
     *
     * playerInstanceID - Type: guid. Desc: mandatory
     *
     * sid - Type: guid. Desc: mandatory
     *
     * compId - Type: string. Desc: player_id
     *
     * sessionId - Type: string. Desc: session id
     *
     * type - Type: string. Desc: video / track / download_only
     *
     * visitorId - Type: guid. Desc: visitor_id, mandatory
     * @param {widgetEpisodeStatsParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.widgetEpisodeStats = function (params) {
        return this.bi.log(__assign({ evid: 911 }, params));
    };
    /**
    * @typedef {Object} mainEpisodeClickParams
    * @property {string} artifactVersion - app version for debug, not mandatory
    * @property {string} episodeId - episode id
    * @property {string} feedId - feed id
    * @property {GUID} playerInstanceID - mandatory
    * @property {GUID} sid - mandatory
    * @property {string} compId - player_id
    * @property {string} sessionId - session id
    * @property {GUID} visitorId - visitor_id, mandatory
    **/
    /**
     * Name: widget.main.episode.click. Evid: 901.
     * Event description: User clicks on Episode in episode list on main podcast page.
    
     * artifactVersion - Type: string. Desc: app version for debug, not mandatory
     *
     * episodeId - Type: string. Desc: episode id
     *
     * feedId - Type: string. Desc: feed id
     *
     * playerInstanceID - Type: guid. Desc: mandatory
     *
     * sid - Type: guid. Desc: mandatory
     *
     * compId - Type: string. Desc: player_id
     *
     * sessionId - Type: string. Desc: session id
     *
     * visitorId - Type: guid. Desc: visitor_id, mandatory
     * @param {mainEpisodeClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.mainEpisodeClick = function (params) {
        return this.bi.log(__assign({ evid: 901 }, params));
    };
    /**
    * @typedef {Object} loadMoreClickParams
    * @property {string} artifactVersion - null
    * @property {string} feedId - feed id
    * @property {GUID} playerInstanceID - null
    * @property {GUID} sid - null
    * @property {string} compId - player_id
    * @property {string} sessionId - null
    **/
    /**
     * Name: widget.loadMore.click. Evid: 912.
     * Event description: UoU clicks on Load More on main podcast page.
    
     * artifactVersion - Type: string.
     *
     * feedId - Type: string. Desc: feed id
     *
     * playerInstanceID - Type: guid.
     *
     * sid - Type: guid.
     *
     * compId - Type: string. Desc: player_id
     *
     * sessionId - Type: string.
     * @param {loadMoreClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.loadMoreClick = function (params) {
        return this.bi.log(__assign({ evid: 912 }, params));
    };
    /**
    * @typedef {Object} episodePlayRequestedParams
    * @property {string} artifactVersion - app version for debug, not mandatory
    * @property {string} correlationId - one uniq guid per one load process
    * @property {number} duration - don't send, we got it in 911
    * @property {string} episodeId - episode id
    * @property {string} feedId - feed id
    * @property {GUID} playerInstanceID - mandatory
    * @property {GUID} sid - mandatory
    * @property {string} compId - player_id
    * @property {string} sessionId - session id
    * @property {string} type - video / track
    * @property {GUID} visitorId - visitor_id, mandatory
    **/
    /**
     * Name: widget.episode.play.requested. Evid: 907.
     * Event description: User clicks on the play on podcast player.
    
     * artifactVersion - Type: string. Desc: app version for debug, not mandatory
     *
     * correlationId - Type: string. Desc: one uniq guid per one load process
     *
     * duration - Type: numeric. Desc: don't send, we got it in 911
     *
     * episodeId - Type: string. Desc: episode id
     *
     * feedId - Type: string. Desc: feed id
     *
     * playerInstanceID - Type: guid. Desc: mandatory
     *
     * sid - Type: guid. Desc: mandatory
     *
     * compId - Type: string. Desc: player_id
     *
     * sessionId - Type: string. Desc: session id
     *
     * type - Type: string. Desc: video / track
     *
     * visitorId - Type: guid. Desc: visitor_id, mandatory
     * @param {episodePlayRequestedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.episodePlayRequested = function (params) {
        return this.bi.log(__assign({ evid: 907 }, params));
    };
    /**
    * @typedef {Object} episodePlayStartedParams
    * @property {string} artifactVersion - app version for debug, not mandatory
    * @property {string} correlationId - one uniq guid per one load process
    * @property {number} duration - don't send, we got it in 911
    * @property {string} episodeId - episode id
    * @property {string} feedId - feed id
    * @property {GUID} playerInstanceID - mandatory
    * @property {GUID} sid - mandatory
    * @property {string} compId - player_id
    * @property {string} sessionId - session id
    * @property {string} type - video / track
    * @property {GUID} visitorId - visitor_id, mandatory
    **/
    /**
     * Name: widget.episode.play.started. Evid: 908.
     * Event description: User clicks on the play on podcast player and play starts.
    
     * artifactVersion - Type: string. Desc: app version for debug, not mandatory
     *
     * correlationId - Type: string. Desc: one uniq guid per one load process
     *
     * duration - Type: numeric. Desc: don't send, we got it in 911
     *
     * episodeId - Type: string. Desc: episode id
     *
     * feedId - Type: string. Desc: feed id
     *
     * playerInstanceID - Type: guid. Desc: mandatory
     *
     * sid - Type: guid. Desc: mandatory
     *
     * compId - Type: string. Desc: player_id
     *
     * sessionId - Type: string. Desc: session id
     *
     * type - Type: string. Desc: video / track
     *
     * visitorId - Type: guid. Desc: visitor_id, mandatory
     * @param {episodePlayStartedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.episodePlayStarted = function (params) {
        return this.bi.log(__assign({ evid: 908 }, params));
    };
    /**
    * @typedef {Object} episodeDownloadClickParams
    * @property {string} artifactVersion - app version for debug, not mandatory
    * @property {string} episodeId - episode id
    * @property {string} feedId - feed id
    * @property {GUID} playerInstanceID - mandatory
    * @property {GUID} sid - mandatory
    * @property {string} compId - player_id
    * @property {string} sessionId - session id
    * @property {string} type - video / track
    * @property {string} url - download url
    * @property {GUID} visitorId - visitor_id, mandatory
    **/
    /**
     * Name: widget.episode.download.click. Evid: 909.
     * Event description: User clicks on episode download button.
    
     * artifactVersion - Type: string. Desc: app version for debug, not mandatory
     *
     * episodeId - Type: string. Desc: episode id
     *
     * feedId - Type: string. Desc: feed id
     *
     * playerInstanceID - Type: guid. Desc: mandatory
     *
     * sid - Type: guid. Desc: mandatory
     *
     * compId - Type: string. Desc: player_id
     *
     * sessionId - Type: string. Desc: session id
     *
     * type - Type: string. Desc: video / track
     *
     * url - Type: string. Desc: download url
     *
     * visitorId - Type: guid. Desc: visitor_id, mandatory
     * @param {episodeDownloadClickParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.episodeDownloadClick = function (params) {
        return this.bi.log(__assign({ evid: 909 }, params));
    };
    /**
    * @typedef {Object} feedLoadCompletedParams
    * @property {string} artifactVersion - app version for debug, not mandatory
    * @property {string} correlationId - one uniq guid per one load process
    * @property {string} errorType - error
    * @property {string} feedId - feed id
    * @property {GUID} playerInstanceID - mandatory
    * @property {boolean} isServerSide - is server
    * @property {number} loadTime - in ms
    * @property {GUID} sid - mandatory
    * @property {string} pageType - main / episode
    * @property {string} compId - player_id
    * @property {string} sessionId - session id
    * @property {boolean} success - true / false
    * @property {GUID} visitorId - visitor_id, mandatory
    **/
    /**
     * Name: widget.feed.load.completed. Evid: 903.
     * Event description: Widget feed load completed.
    
     * artifactVersion - Type: string. Desc: app version for debug, not mandatory
     *
     * correlationId - Type: string. Desc: one uniq guid per one load process
     *
     * errorType - Type: string. Desc: error
     *
     * feedId - Type: string. Desc: feed id
     *
     * playerInstanceID - Type: guid. Desc: mandatory
     *
     * isServerSide - Type: bool. Desc: is server
     *
     * loadTime - Type: numeric. Desc: in ms
     *
     * sid - Type: guid. Desc: mandatory
     *
     * pageType - Type: string. Desc: main / episode
     *
     * compId - Type: string. Desc: player_id
     *
     * sessionId - Type: string. Desc: session id
     *
     * success - Type: bool. Desc: true / false
     *
     * visitorId - Type: guid. Desc: visitor_id, mandatory
     * @param {feedLoadCompletedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.feedLoadCompleted = function (params) {
        return this.bi.log(__assign({ evid: 903 }, params));
    };
    /**
    * @typedef {Object} feedLoadRequestedParams
    * @property {string} artifactVersion - app version for debug, not mandatory
    * @property {string} correlationId - one uniq guid per one load process
    * @property {string} feedId - feed id
    * @property {GUID} playerInstanceID - mandatory
    * @property {boolean} isServerSide - is server
    * @property {GUID} sid - mandatory
    * @property {string} pageType - main / episode
    * @property {string} compId - player_id
    * @property {string} sessionId - session id
    * @property {GUID} visitorId - visitor_id, mandatory
    **/
    /**
     * Name: widget.feed.load.requested. Evid: 902.
     * Event description: Widget feed load requested.
    
     * artifactVersion - Type: string. Desc: app version for debug, not mandatory
     *
     * correlationId - Type: string. Desc: one uniq guid per one load process
     *
     * feedId - Type: string. Desc: feed id
     *
     * playerInstanceID - Type: guid. Desc: mandatory
     *
     * isServerSide - Type: bool. Desc: is server
     *
     * sid - Type: guid. Desc: mandatory
     *
     * pageType - Type: string. Desc: main / episode
     *
     * compId - Type: string. Desc: player_id
     *
     * sessionId - Type: string. Desc: session id
     *
     * visitorId - Type: guid. Desc: visitor_id, mandatory
     * @param {feedLoadRequestedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.feedLoadRequested = function (params) {
        return this.bi.log(__assign({ evid: 902 }, params));
    };
    /**
    * @typedef {Object} navigationCompletedParams
    * @property {string} artifactVersion - app version for debug, not mandatory
    * @property {string} correlationId - one uniq guid per one load process
    * @property {string} episodeId - episode id
    * @property {string} errorType - error
    * @property {string} feedId - feed id
    * @property {GUID} playerInstanceID - mandatory
    * @property {GUID} sid - mandatory
    * @property {string} pageType - (where users tries to go (episode / main)
    * @property {string} compId - player_id
    * @property {string} sessionId - session id
    * @property {boolean} success - true / false
    * @property {GUID} visitorId - visitor_id, mandatory
    **/
    /**
     * Name: wigdet.navigation.completed. Evid: 906.
     * Event description: User of user goes to another page in an app.
    
     * artifactVersion - Type: string. Desc: app version for debug, not mandatory
     *
     * correlationId - Type: string. Desc: one uniq guid per one load process
     *
     * episodeId - Type: string. Desc: episode id
     *
     * errorType - Type: string. Desc: error
     *
     * feedId - Type: string. Desc: feed id
     *
     * playerInstanceID - Type: guid. Desc: mandatory
     *
     * sid - Type: guid. Desc: mandatory
     *
     * pageType - Type: string. Desc: (where users tries to go (episode / main)
     *
     * compId - Type: string. Desc: player_id
     *
     * sessionId - Type: string. Desc: session id
     *
     * success - Type: bool. Desc: true / false
     *
     * visitorId - Type: guid. Desc: visitor_id, mandatory
     * @param {navigationCompletedParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.navigationCompleted = function (params) {
        return this.bi.log(__assign({ evid: 906 }, params));
    };
    /**
    * @typedef {Object} dummyEventParams
    * @property {string} artifactVersion - null
    * @property {GUID} playerInstanceID - null
    * @property {GUID} sid - null
    * @property {string} sessionId - null
    **/
    /**
     * Name: dummy event. Evid: 900.
     * Event description: 901-949 appSet events; 950-999 widget events; 1000+ BE events.
    
     * artifactVersion - Type: string.
     *
     * playerInstanceID - Type: guid.
     *
     * sid - Type: guid.
     *
     * sessionId - Type: string.
     * @param {dummyEventParams} params The parameters for this event.
     * @return {Promise}
    **/
    Logger.prototype.dummyEvent = function (params) {
        return this.bi.log(__assign({ evid: 900 }, params));
    };
    return Logger;
}());
exports.Logger = Logger;
exports.default = init;
//# sourceMappingURL=index.js.map